import { StepCardContent } from './StepCard'
import { Button, Textarea } from '@bpinternal/ui-kit-next'
import { useStepNavStore } from '../../stores/useStepNavStore'
import { getUseBotOnboardingStore } from '../../stores/useBotOnboardingStore'
import { useEffect, useRef } from 'react'
import { ArrowLeft } from 'lucide-react'

const MAX_CHARACTERS = 1500

type Props = {
  workspaceId: string
  botId: string
}

export const BotDescriptionStep = ({ workspaceId, botId }: Props) => {
  const useBotOnboardingStore = getUseBotOnboardingStore({ workspaceId, botId })
  const userPrompt = useBotOnboardingStore((state) => state.userPrompt)
  const onboardingStep = useBotOnboardingStore((state) => state.onboardingStep)
  const setUserPrompt = useBotOnboardingStore((state) => state.setUserPrompt)
  const setOnboardingStep = useBotOnboardingStore((state) => state.setOnboardingStep)
  const setNextDisabled = useStepNavStore((state) => state.setNextDisabled)
  const setProgressBarStep = useStepNavStore((state) => state.setProgressBarStep)
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    setNextDisabled(userPrompt.length === 0)
  }, [userPrompt])

  useEffect(() => {
    setProgressBarStep(2)
    textAreaRef.current?.focus()
  }, [])

  const handleNewInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value
    if (value.length <= MAX_CHARACTERS) {
      setUserPrompt(value)
    }
  }

  return (
    <StepCardContent
      className="flex flex-1"
      title="Goal"
      description="Describe your bot’s primary goal so we can tailor its behavior."
    >
      <div className="flex flex-1 flex-col gap-2">
        <Button
          variant="ghost"
          className="text-md self-start"
          onClick={() => {
            if (onboardingStep > 0) setOnboardingStep(onboardingStep - 1)
          }}
        >
          <ArrowLeft size={16} />
          Back to all use cases
        </Button>
        <Textarea
          className="flex-1 resize-none"
          ref={textAreaRef}
          value={userPrompt}
          onChange={handleNewInput}
          placeholder={`Describe the role of this AI agent in less than ${MAX_CHARACTERS} characters`}
        />
        <p className="text-end text-sm text-muted-foreground">
          {MAX_CHARACTERS - userPrompt.length} characters remaining
        </p>
      </div>
    </StepCardContent>
  )
}
